import clsx from 'clsx'
import styles from './spinner.module.scss'

interface Props {
    containerClassName?: string
}

export default function Spinner({ containerClassName }: Props) {
    return (
        <div className={`${styles.spinner} ${containerClassName}`} role="status">
            {[...Array(12).keys()].map((index) => (
                <div key={index} className={clsx(styles[`bar${index + 1}`], styles.bar)} />
            ))}
        </div>
    )
}
